(function () {
  if (!window.__recaptchaWidgetIds) {
    window.__recaptchaWidgetIds = new WeakMap();
  }

  window.renderRecaptchaV2 = function (root) {
    if (!root) return;
    if (!window.grecaptcha || typeof window.grecaptcha.render !== 'function') return;

    var nodes = root.querySelectorAll('.g-recaptcha');
    nodes.forEach(function (el) {
      if (window.__recaptchaWidgetIds.has(el)) return;

      var sitekey = el.getAttribute('data-sitekey');
      if (!sitekey) {
        var meta = document.querySelector('meta[name="recaptcha-sitekey"]');
        if (meta) sitekey = meta.getAttribute('content');
      }
      if (!sitekey) return;

      el.innerHTML = '';

      var widgetId = window.grecaptcha.render(el, { sitekey: sitekey });
      window.__recaptchaWidgetIds.set(el, widgetId);
    });
  };

  window.onRecaptchaLoad = function () {
    window.renderRecaptchaV2(document);
  };
})();
